module.exports = __webpack_public_path__ + "assets/img/dehydrate.e792893f.png";